import Status from './status.element.js';

export default Status;

Status.define('wje-status', Status);
